<template>
	<div class="d-flex flex-row align-content-center px-0">
		<botao-tooltip icone="search" cor="grey" texto="Detalhes da Ata" @click="acessarAta(ata.id)"></botao-tooltip>
		<botao-tooltip
			icone="mdi-account-group"
			cor="grey"
			texto="Órgãos Participantes"
			@click="abrirModalOrgaosParticipantes"
		></botao-tooltip>
		<botao-tooltip
			v-if="ata.existeDocumentoAta"
			icone="mdi-file-document"
			cor="grey"
			texto="Documentos"
			@click="abrirOufecharModalBaixarArquivos"
		></botao-tooltip>

		<modal-documentos
			v-if="exibirModalBaixarArquivos"
			:idAta="ata.id"
			:exibir="exibirModalBaixarArquivos"
			@fechar-modal="abrirOufecharModalBaixarArquivos"
		></modal-documentos>
	</div>
</template>

<script>
import { routesNames } from '@/core/constants'
import ModalDocumentos from '@/views/pages/ata/pesquisa/listagem/modal-documentos/ModalDocumentos'

export default {
	name: 'ata-listagem-botoes-acoes',
	components: { ModalDocumentos },
	props: {
		ata: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			exibirModalBaixarArquivos: false,
		}
	},
	methods: {
		abrirOufecharModalBaixarArquivos() {
			this.exibirModalBaixarArquivos = !this.exibirModalBaixarArquivos
		},
		abrirModalOrgaosParticipantes() {
			this.$emit('abrir-modal-orgaos-participantes', this.ata.id)
		},
		acessarAta(idAta) {
			this.$router.push({
				name: routesNames.ATA.ATA_ACESSAR_VIEW,
				params: { id: idAta },
			})
		},
	},
}
</script>

<style scoped></style>
